import { computed } from '@vue/composition-api'

export function useTipoDeSolicitacaoAlteracoes(historico) {
  const tipoDeSolicitacaoFoiAlterado = computed(
    () => !!historico.value.tipoSolicitacaoNome && !!historico.value.tipoSolicitacaoNomeAnterior,
  )
  const paresDeValoresTipoDeSolicitacao = computed(() => [
    {
      contentTitle: 'Nome',
      currentValue: historico.value.tipoSolicitacaoNome,
      previousValue: historico.value.tipoSolicitacaoNomeAnterior,
    },
  ])
  return { tipoDeSolicitacaoFoiAlterado, paresDeValoresTipoDeSolicitacao }
}

export function useStatusAlteracoes(historico) {
  const statusFoiAlterado = computed(() => !!historico.value.statusNome && !!historico.value.statusNomeAnterior)
  const paresDeValoresStatus = computed(() => [
    {
      contentTitle: 'Nome',
      currentValue: historico.value.statusNome,
      previousValue: historico.value.statusNomeAnterior,
    },
  ])
  return { statusFoiAlterado, paresDeValoresStatus }
}

export function useIntegranteAlteracoes(historico) {
  const integranteFoiAlterado = computed(
    () => !!historico.value.integranteNome && !!historico.value.integranteNomeAnterior,
  )
  const paresDeValoresIntegrante = computed(() => [
    {
      contentTitle: 'Nome',
      currentValue: historico.value.integranteNome,
      previousValue: historico.value.integranteNomeAnterior,
    },
  ])
  return { integranteFoiAlterado, paresDeValoresIntegrante }
}
